import BaseApiClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkContentDetailApi extends BaseApiClient {
  public getDetail (id: string) {
    const path: string = '/v1/external-link-contents/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new ExternalLinkContentDetailApi()
